import React from "react";
import PropTypes from "prop-types";
import { Box, InputBase, IconButton, Tooltip } from "@mui/material";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import StopIcon from "@mui/icons-material/Stop";

const ChatInput = ({
  input,
  setInput,
  onSendMessage,
  onCancel,
  isLoading,
}) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey && (input?.trim?.() || "")) {
      e.preventDefault();
      onSendMessage();
    }
  };
  return (
    <Box
      sx={{
        padding: "0 10px 15px 10px",
        zIndex: 1,
        display: "flex",
        justifyContent: "center",
        transition: "all 0.3s ease",
        boxSizing: "border-box",
      }}
    >
      {/* Pill container */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          maxWidth: "860px",
          backgroundColor: "#fff",
          borderRadius: "50px",
          border: "1px solid #E2E8F0",
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
          padding: "6px 6px 6px 4px",
          gap: 0.5,
        }}
      >
        {/* Text input */}
        <InputBase
          fullWidth
          placeholder={isLoading ? "Generating response…" : "Ask Anything"}
          id="inputtext"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={isLoading}
          sx={{
            flex: 1,
            fontFamily: "'Poppins', sans-serif",
            fontSize: "0.95rem",
            color: "#1B2559",
            px: 1,
            ml: 1,
            "& input::placeholder": {
              color: "#A0AEC0",
              opacity: 1,

            },
          }}
        />
        {/* Send / Cancel button */}
        <Tooltip title={isLoading ? "Cancel request" : "Send message"} placement="top">
          <IconButton
            onClick={isLoading ? onCancel : onSendMessage}
            sx={{
              backgroundColor: isLoading ? "#d32f2f" : "#111827",
              color: "#fff",
              width: 40,
              height: 40,
              borderRadius: "50%",
              flexShrink: 0,
              "&:hover": {
                backgroundColor: isLoading ? "#b71c1c" : "#374151",
              },
              transition: "background-color 0.2s ease",
            }}
          >
            {isLoading ? (
              <StopIcon sx={{ fontSize: 20 }} />
            ) : (
              <GraphicEqIcon sx={{ fontSize: 20 }} />
            )}
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

ChatInput.propTypes = {
  input: PropTypes.string.isRequired,
  setInput: PropTypes.func.isRequired,
  onSendMessage: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default ChatInput;

